import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import Vuelidate from 'vuelidate';
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { apiService } from "@/services/apiService";
import "@/assets/css/main.css";


Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.apiService = apiService;

Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);


Vue.mixin(
    {
      methods: {
        isEmpty: function (value) {
          switch (value) {
            case "":
              return true;
            case 0:
              return true;
            case "0":
              return true;
            case null:
              return true;
            case false:
              return true;
            case undefined:
              return true;
            case typeof (value) === "undefined":
              return true;
            default:
              return false;
          }
        }
      }
    }
);

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = event => {
      if (el === event.target || el.contains(event.target)) return
      vnode.context[binding.expression](event);
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

new Vue({
  render: h => h(App),
}).$mount('#app');
